import React from 'react';
const comparisonRows = [{
  situation: 'Tu enfoque',
  without: 'Improvisás cada semana',
  with: 'Sistema listo mes a mes'
}, {
  situation: 'Las actividades',
  without: 'Las buscás en Google sin saber si sirven',
  with: 'Listas, organizadas y validadas'
}, {
  situation: 'Los hitos',
  without: 'No sabés si tu hijo va bien o no',
  with: 'Checklists claros por mes'
}, {
  situation: 'Las alertas',
  without: 'Las notás tarde o no las notás',
  with: 'Semáforo de alertas por etapa'
}, {
  situation: 'Tu confianza',
  without: 'Dudás de si lo hacés bien',
  with: 'Sabés exactamente qué hacer'
}, {
  situation: 'El tiempo',
  without: 'Horas buscando información dispersa',
  with: 'Todo en un solo sistema'
}, {
  situation: 'El desarrollo motor',
  without: 'Sin protocolo claro',
  with: 'Actividades por mes y área'
}, {
  situation: 'El lenguaje',
  without: 'Esperás y rezás',
  with: 'Protocolo de estimulación activo'
}];
const blocks = [{
  num: '01',
  emoji: '🧠',
  title: 'Protocolo de Neurodesarrollo Avanzado',
  desc: 'Estimulación neurológica profunda para potenciar al máximo cada etapa.'
}, {
  num: '02',
  emoji: '📋',
  title: 'Plan de Estimulación Semanal',
  desc: 'Semana a semana organizada con actividades específicas por área.'
}, {
  num: '03',
  emoji: '📱',
  title: 'Guía de Comunicación con el Bebé',
  desc: 'Scripts y guiones para hablarle, estimularlo y vincularte mejor cada día.'
}, {
  num: '04',
  emoji: '📊',
  title: 'Registro de Progreso Avanzado',
  desc: 'Seguimiento completo del desarrollo con indicadores claros por área.'
}];
const assets = ['Registro de hitos ampliado', 'Planilla de progreso semanal', 'Guía de señales de alerta extendida', 'Protocolo de des-estimulación', 'Actividades para papá y familia', 'Guiones de comunicación verbal', 'Calendario de estimulación mensual'];
export function ProBusiness() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-16 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(253,244,255) 0%, rgb(243,232,255) 15%, rgb(243,232,255) 85%, rgb(253,244,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-224">
      <div className="mx-auto max-w-4xl flex flex-col gap-12" data-id="element-225">

        {/* ── HEADER ── */}
        <div className="text-center flex flex-col items-center gap-3" data-id="element-226">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide rounded-full px-4 py-1.5" style={{
          color: '#7c3aed',
          border: '1px solid rgba(124,58,237,0.30)',
          background: 'rgba(124,58,237,0.05)'
        }} data-id="element-227">
            🏆 Solo disponible en Megapack Pro
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900 m-0 leading-tight" data-id="element-228">
            ¿Qué agrega{' '}
            <span style={{
            background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-229">
              Neurodesarrollo Avanzado™?
            </span>
          </h2>
          <p className="text-sm text-gray-500 max-w-lg m-0" data-id="element-230">
            El protocolo de estimulación profunda para madres que quieren ir un
            paso más allá y potenciar al máximo el desarrollo de su hijo.
          </p>
        </div>

        {/* ── COMPARISON TABLE ── */}
        <div className="flex flex-col gap-2" data-id="element-231">
          <p className="text-xs text-gray-400 text-center sm:hidden flex items-center justify-center gap-1" data-id="element-232">
            <span data-id="element-233">👆</span> Deslizá para ver la tabla completa
          </p>
          <div className="overflow-x-auto rounded-2xl shadow-md touch-pan-x" style={{
          border: '1px solid rgba(168,85,247,0.20)',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-234">
            <div className="min-w-[560px] bg-white rounded-2xl overflow-hidden" data-id="element-235">

              {/* Table Header */}
              <div className="grid grid-cols-3" style={{
              background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)'
            }} data-id="element-236">
                <div className="px-4 py-3 text-xs font-bold text-white/70 uppercase tracking-wide" data-id="element-237">
                  Situación
                </div>
                <div className="px-4 py-3 text-xs font-bold text-white/70 uppercase tracking-wide border-l border-white/10 text-center" data-id="element-238">
                  ❌ Sin el Megapack
                </div>
                <div className="px-4 py-3 text-xs font-bold text-white uppercase tracking-wide border-l border-white/10 text-center" data-id="element-239">
                  ✅ Con el Megapack
                </div>
              </div>

              {/* Table Rows */}
              {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-240">
                  <div className="px-4 py-3 text-xs font-bold text-gray-900" data-id="element-241">
                    {row.situation}
                  </div>
                  <div className="px-4 py-3 text-xs text-gray-400 border-l border-gray-100 bg-gray-50 text-center" data-id="element-242">
                    {row.without}
                  </div>
                  <div className="px-4 py-3 text-xs font-semibold text-gray-900 border-l border-gray-100 text-center" style={{
                backgroundColor: 'rgba(124,58,237,0.04)'
              }} data-id="element-243">
                    {row.with}
                  </div>
                </div>)}

            </div>
          </div>
        </div>

        {/* ── BLOCKS GRID ── */}
        <div className="flex flex-col gap-3" data-id="element-244">
          <h3 className="text-xs font-bold uppercase tracking-widest text-center m-0" style={{
          color: '#7c3aed'
        }} data-id="element-245">
            🏆 Neurodesarrollo Avanzado™ incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-246">
            {blocks.map(block => <div key={block.num} className="flex items-start gap-4 bg-white rounded-2xl px-5 py-4 shadow-sm" style={{
            border: '1px solid rgba(168,85,247,0.20)'
          }} data-id="element-247">
                <div className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center text-lg" style={{
              background: 'rgba(124,58,237,0.08)'
            }} data-id="element-248">
                  {block.emoji}
                </div>
                <div className="flex-1 min-w-0" data-id="element-249">
                  <span className="block text-[10px] font-black uppercase tracking-widest mb-1" style={{
                color: 'rgba(168,85,247,0.6)'
              }} data-id="element-250">
                    {block.num}
                  </span>
                  <span className="block text-sm font-black text-gray-900 leading-tight mb-1" data-id="element-251">
                    {block.title}
                  </span>
                  <span className="block text-xs text-gray-500 leading-5" data-id="element-252">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* ── ASSETS ── */}
        <div className="rounded-2xl px-6 py-5" style={{
        background: 'rgba(124,58,237,0.04)',
        border: '1px solid rgba(168,85,247,0.20)'
      }} data-id="element-253">
          <p className="text-xs font-bold uppercase tracking-widest m-0 mb-4 text-center" style={{
          color: '#7c3aed'
        }} data-id="element-254">
            📊 Assets incluidos
          </p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-255">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold bg-white rounded-full px-3 py-1.5 shadow-sm" style={{
            color: '#7c3aed',
            border: '1px solid rgba(168,85,247,0.25)'
          }} data-id="element-256">
                {asset}
              </span>)}
          </div>
        </div>

      </div>
    </section>;
}